export default __webpack_public_path__ + "f7b426927f7699dc410953dfcdd9957c.png";